module.exports = __webpack_public_path__ + "img/rss-blue.634e6f6c.png";